import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    if (!isHomePage) {
      setScrolled(true);
      return;
    }
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHomePage]);

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
      setMobileMenuOpen(false);
    }
  };

  const navLinks = [
    { label: "Rešenja", id: "solutions" },
    { label: "Proizvodi", id: "featured-products" },
    { label: "Blog", href: "/blog" },
    { label: "Kontakt", id: "contact" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-3">
            <span className="w-9 h-9 flex items-center justify-center bg-brand-500 rounded-lg">
              <i className="ri-shield-check-line text-white text-lg"></i>
            </span>
            <span
              className={`font-bold text-lg tracking-tight transition-colors ${
                scrolled ? "text-dark-900" : "text-white"
              }`}
            >
              SafeGuard
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) =>
              link.href ? (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`text-sm font-medium transition-colors hover:opacity-70 whitespace-nowrap ${
                    scrolled ? "text-dark-600" : "text-white/90"
                  }`}
                >
                  {link.label}
                </Link>
              ) : (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id!)}
                  className={`text-sm font-medium transition-colors hover:opacity-70 whitespace-nowrap cursor-pointer ${
                    scrolled ? "text-dark-600" : "text-white/90"
                  }`}
                >
                  {link.label}
                </button>
              )
            )}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <button
              onClick={() => navigate("/products")}
              className={`text-sm font-medium transition-colors hover:opacity-70 whitespace-nowrap cursor-pointer ${
                scrolled ? "text-dark-600" : "text-white/90"
              }`}
            >
              Svi proizvodi
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              className="bg-brand-500 hover:bg-brand-600 text-white px-6 py-2.5 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              Besplatna konsultacija
            </button>
          </div>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i
              className={`ri-${mobileMenuOpen ? "close" : "menu"}-line text-xl ${
                scrolled ? "text-dark-900" : "text-white"
              }`}
            ></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-gray-100">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) =>
              link.href ? (
                <Link
                  key={link.href}
                  to={link.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className="block w-full text-left text-dark-700 text-sm font-medium py-2"
                >
                  {link.label}
                </Link>
              ) : (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id!)}
                  className="block w-full text-left text-dark-700 text-sm font-medium py-2 cursor-pointer"
                >
                  {link.label}
                </button>
              )
            )}
            <button
              onClick={() => {
                navigate("/products");
                setMobileMenuOpen(false);
              }}
              className="block w-full text-left text-dark-700 text-sm font-medium py-2 cursor-pointer"
            >
              Svi proizvodi
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              className="w-full bg-brand-500 text-white px-6 py-2.5 rounded-full text-sm font-semibold cursor-pointer"
            >
              Besplatna konsultacija
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}